import { Badge as BadgeMantine, BadgeProps } from "@mantine/core";
import { IColor, variantColors } from "../../../../utils/selectColors";
import { useTranslation } from "react-i18next";

interface IProps extends BadgeProps {
  x: number;
  value: string;
}

export default function TagNuberXValue({ x, value, ...props }: IProps) {
  const selectedVariant = variantColors[IColor.babyBlue];
  const { t } = useTranslation();
  return (
    <BadgeMantine
      styles={{
        root: {
          background: selectedVariant.bg,
          padding: "4px 8px",
          height: "30px",
          fontSize: "16px",
          border: "1.5px solid",
          width: "fit-content",
          borderRadius: "20px",
          borderColor: selectedVariant.borderColor,
        },
      }}
      radius="sm"
      {...props}
    >
      <span style={{ color: "#6B6B6B", textTransform: "lowercase" }}>{`${x}${t(
        "marketplace.detalhe.buy_area.x_of"
      )}`}</span>{" "}
      <span style={{ color: selectedVariant.color }}>{value}</span>
    </BadgeMantine>
  );
}
